import { render, staticRenderFns } from "./UpsertBuildingAccessModal.vue?vue&type=template&id=a1eb0b50"
import script from "./UpsertBuildingAccessModal.vue?vue&type=script&lang=js"
export * from "./UpsertBuildingAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports